export class ConveyanceSegmentResponse {
  ConveyanceSegmentID: number;
  ConveyanceID: number;
  SegmentName: string;
  Ordinal: number;
  ActionID: number;
}
